import type { FunctionComponent } from 'react'

import MegaMenu from './MegaMenu'
import NestedMenu from './NestedMenu'
import OffCanvas from './OffCanvas'
import OverlayMenu from './OverlayMenu'

const menuTypeMap: Record<ThemeMenuTypes, FunctionComponent<any>> = {
  nestedMenu: ThemeNestedMenu,
  megaMenu: ThemeMegaMenu,
}

type MenuProps = {
  navigation: Frontend.NestedPage[]
}

type AdditionalMenuProps = {
  offCanvasDirection?: 'left' | 'right'
}

type Props = {
  shop: Core.FullShop
  themeSettings: Theme.Settings
  navigation: Frontend.NestedPage[]
}

export default function ThemeHeaderMenu(props: Readonly<Props>) {
  const {
    themeSettings,
    shop: { theme },
    navigation,
  } = props

  const selectedMenuType: ThemeMenuTypes = themeSettings?.themeHeader?.menuType
  const selectedHeaderType: ThemeHeaderTypes = themeSettings?.themeHeader?.headerType

  const Menu =
    selectedHeaderType === 'oneRow'
      ? theme.name.startsWith('epages.vision')
        ? ThemeVisionOffCanvasMenu
        : ThemeOverlayMenu
      : menuTypeMap[selectedMenuType]

  const additionalMenuProps: AdditionalMenuProps = {}

  if (theme.name.startsWith('epages.vision') && selectedHeaderType !== 'oneRow') {
    additionalMenuProps.offCanvasDirection = 'right'
  }

  return <Menu navigation={navigation} {...additionalMenuProps} />
}

function ThemeMegaMenu({ navigation, offCanvasDirection = 'left' }: Readonly<MenuProps & AdditionalMenuProps>) {
  return (
    <nav className="navigation" role="navigation">
      <OffCanvas className="navigation-mobile" items={navigation} direction={offCanvasDirection} />
      <MegaMenu className="navigation-desktop" items={navigation} />{' '}
    </nav>
  )
}

function ThemeNestedMenu({ navigation, offCanvasDirection = 'left' }: Readonly<MenuProps & AdditionalMenuProps>) {
  return (
    <nav className="navigation" role="navigation">
      <NestedMenu items={navigation} />
      <OffCanvas className="navigation-mobile" items={navigation} direction={offCanvasDirection} />
    </nav>
  )
}

function ThemeOverlayMenu({ navigation }: Readonly<MenuProps>) {
  return (
    <nav role="navigation">
      <OverlayMenu className="navigation-overlay" items={navigation} />
    </nav>
  )
}

function ThemeVisionOffCanvasMenu({ navigation }: Readonly<MenuProps>) {
  return (
    <nav role="navigation">
      <OffCanvas className="navigation-off-canvas-left" items={navigation} />
    </nav>
  )
}
